/** Format a number as euros with French locale (e.g. 1 234,56). Always 2 decimal places. */
export function formatEuros(value: number): string {
  return value.toLocaleString("fr-FR", {minimumFractionDigits: 2, maximumFractionDigits: 2});
}
